import { Component, ComponentFactoryResolver, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { GlobalCfgService } from '../../../services/globalcfg.service';
import { ManufacturerDashboardComponent } from '../../../components/manufacturer-dashboard/manufacturer-dashboard.component';
import { AppViewDirective } from '../../app-view.directive';
import { ProductsListComponent } from '../../../components/products-list/products-list.component';
import { IncidentsComponent } from '../../../components/incidents/incidents.component';
import { LocationsComponent } from '../../../components/locations/locations.component';
import { ExpiryReportComponent } from '../../../components/expiry-report/expiry-report.component';
import { RecallSimulationComponent } from '../../../components/recall-simulation/recall-simulation.component';
import { RecallReportComponent } from '../../../components/recall-report/recall-report.component';
import { ManageBatchComponent } from '../../../components/manage-batch/manage-batch.component';
import { ManageMedicineComponent } from '../../../components/manage-medicine/manage-medicine.component';
import { ManageLocationComponent } from '../../../components/manage-location/manage-location.component';
import { EditProfileComponent } from '../../../components/edit-profile/edit-profile.component';
import { ManageLabelComponent } from '../../../components/manage-label/manage-label.component';
import { MiscService } from '../../../services/misc.service';
import { EventBusService } from '../../../services/event-bus.service';
import { ManageManufacturerComponent } from 'src/components/manage-organisation/manage-organisation.component';
import { ManageRoleComponent } from 'src/components/manage-role/manage-role.component';
import { ManageUserComponent } from 'src/components/manage-user/manage-user.component';
import { ManageNotificationsComponent } from 'src/components/manage-notifications/manage-notifications.component';
import { ManageSegmentComponent } from 'src/components/manage-segment/manage-segment.component';
import { ManageChainComponent } from 'src/components/manage-chain/manage-chain.component';
import { SidenavbarViewService } from '../../../services/sidenavbar-view.service';

@Component({
	selector: 'rm-admin',
	templateUrl: './admin.component.html',
	styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit, OnDestroy {

	@ViewChild(AppViewDirective, {static: true}) appViewHost: AppViewDirective;
	role: any;
	view: any;
	subcriptions: any[] = [];
	
	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private route: ActivatedRoute,
		private globalCfgService: GlobalCfgService,
		private miscService: MiscService,
		private ebService: EventBusService,
		private sidenavbarViewService: SidenavbarViewService
	) {}

	ngOnInit() {
		this.route.parent.url.subscribe((url) => {
			var v = url.values();
			//always the first part is role
			this.role = v.next().value.path;
		});
		
		this.route.url.subscribe((url)=> {
			var v = url.values()
			this.view = v.next().value.path;
			this.sidenavbarViewService.childView = this.view;
		});
		
		this.miscService.getACL('admin').subscribe(
			(acls: any[])=> {
				var acl = JSON.parse(acls[0].value);

				this.globalCfgService.setAcl(acl);
				this.ebService.onReadySource.next();
			}
		);

        this.ebService.onReadySource.next();
		this.subcriptions.push(this.ebService.onReadyValue$.subscribe(
			()=> {
				var cmpMap = {
					'dashboard': ManufacturerDashboardComponent,
					'products': ProductsListComponent,
					'incidents': IncidentsComponent,
					'locations': LocationsComponent,
					'expiry-report': ExpiryReportComponent,
					'batch-recall': RecallSimulationComponent,
					'recall-report': RecallReportComponent,
					'manage-batch': ManageBatchComponent,
					'manage-medicine': ManageMedicineComponent,
					'manage-location': ManageLocationComponent,
					'manage-profile': EditProfileComponent,
					'manage-label': ManageLabelComponent,
					'manage-manufacturer': ManageManufacturerComponent,
					'manage-role': ManageRoleComponent,
					'manage-user': ManageUserComponent,
					'manage-chain': ManageChainComponent,
					'manage-segments': ManageSegmentComponent,
					'manage-notifications': ManageNotificationsComponent
				};
		
				var type = this.route.data['value']['type'];
		
				let componentFactory;
		        console.log(type);
				if (!type) {
					componentFactory = this.componentFactoryResolver.resolveComponentFactory(ManufacturerDashboardComponent);
				} else {
					console.log('cmp',cmpMap[type]);
					componentFactory = this.componentFactoryResolver.resolveComponentFactory(cmpMap[type]);
				}
		        console.log(componentFactory);
				const viewContainerRef = this.appViewHost.viewContainerRef;
				viewContainerRef.clear();
		
				let componentRef = viewContainerRef.createComponent(componentFactory);
			}
		));
	}

	ngOnDestroy() {
		this.subcriptions.forEach(s => s.unsubscribe());
	}
}
